// The simulated portfolio fleet behind /concepts/portfolio: twelve
// companies, two to four Kit instances each, in the shape deriveFleet reads
// for an organization (apps grouped by workspace = company). Pure data so it
// can be checked in node; nothing here is anyone's data.
const NOW = Date.now();
const COMPANIES = [
  ['northline', 'Northline Logistics'], ['harborpt', 'Harbor Point Dental'], ['ledgerln', 'Ledgerline Services'],
  ['fieldnote', 'Fieldnotes Facilities'], ['atlasmfg', 'Atlas Manufacturing'], ['relaycare', 'Relay Home Care'],
  ['kilnworks', 'Kilnworks Ceramics'], ['mesaenergy', 'Mesa Energy'], ['summitins', 'Summit Insurance'],
  ['brightlab', 'Brightlab Diagnostics'], ['cedarfood', 'Cedar Foods'], ['tidewater', 'Tidewater Marine'],
];
const APPS = [['ops', 'Ops'], ['portal', 'Portal'], ['field', 'Field'], ['billing', 'Billing']];

const inst = (co, app, k, extra = {}) => ({
  id: `app-${co}-${app}`, slug: `${co}-${app}`, name: `${COMPANIES.find((c) => c[0] === co)[1].split(' ')[0]} · ${APPS.find((a) => a[0] === app)[1]}`,
  status: 'live', workspaceId: co, plan: k % 2 ? 'kit-business' : 'kit', envRole: 'prod',
  monitor: { state: 'up', lastCheckAt: NOW - 20e3, lastLatencyMs: 120 + (k * 37) % 160, tlsDaysLeft: 40 + (k * 13) % 50, services: [
    { name: 'edge', kind: 'service', state: 'running', health: 'healthy' }, { name: 'api', kind: 'service', state: 'running', health: 'healthy' },
    { name: 'workers', kind: 'service', state: 'running', health: 'healthy' }, { name: 'db', kind: 'service', state: 'running', health: 'healthy' },
  ], servicesAt: NOW - 30e3 },
  scan: { counts: { critical: 0, high: 0 }, lastScanAt: NOW - 86400e3 * (1 + k % 5) },
  repo: { kitRef: '7768df8' }, urls: { app: `https://${co}-${app}.apps.example` },
  ...extra,
});

export function portfolioFixture() {
  const apps = [];
  let k = 0;
  COMPANIES.forEach(([co], ci) => {
    const n = 2 + (ci % 3); // two to four instances per company
    for (let a = 0; a < n; a++) apps.push(inst(co, APPS[a][0], k++));
  });
  // A few true things about any fleet of forty: one degraded, one down, one
  // provisioning, one with a scan finding, one drifting behind the kit.
  const by = (slug) => apps.find((x) => x.slug === slug);
  Object.assign(by('harborpt-portal'), { monitor: { ...by('harborpt-portal').monitor, state: 'degraded', consecFails: 1, lastLatencyMs: 2100 } });
  Object.assign(by('mesaenergy-ops'), { monitor: { state: 'down', consecFails: 3, lastCheckAt: NOW - 5e3 } });
  Object.assign(by('tidewater-portal'), { status: 'provisioning', provisioning: { stage: 'stack', stages: [{ name: 'repo', status: 'done', at: NOW - 60e3 }, { name: 'host', status: 'done', at: NOW - 50e3 }] } });
  Object.assign(by('relaycare-ops'), { scan: { counts: { critical: 0, high: 2 }, lastScanAt: NOW - 3600e3 } });
  Object.assign(by('kilnworks-portal'), { repo: { kitRef: '1a2b3c4' } });
  const byApp = Object.fromEntries(apps.map((a, i) => [a.id, { mtdUsd: 18 + (i * 7.3) % 90, burnPerDayUsd: 0.7 + (i % 5) * 0.4, projectedUsd: 40 + (i * 11) % 160, lastActivityAt: NOW - (i % 7) * 3600e3 }]));
  return {
    mode: 'org',
    org: { id: 'org-portfolio', name: 'Portfolio (simulated)' },
    apps,
    orgCost: { byApp, totalUsd: Object.values(byApp).reduce((s, c) => s + c.mtdUsd, 0) },
    usage: null,
    incidents: [{ id: 'inc-mesa', slug: 'mesaenergy-ops', status: 'open', kind: 'probe', reason: 'probe failed ×3', openedAt: NOW - 8 * 60e3 }],
  };
}
